var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPdf = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 17,
    viewBox: "0 0 15 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.699951,
    width: 13.6,
    height: 17,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.42662 1.13333L13.1666 4.98667V15.8667H1.83328V1.13333H9.42662ZM9.87995 0H0.699951V17H14.3V4.53333L9.87995 0Z",
    fill: "#C74343"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.19995 5.1V0.566666H9.53995L13.7333 4.76V5.1H9.19995Z",
    fill: "#FFD9D9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.76647 1.58667L12.7131 4.53333H9.76647V1.58667ZM9.76647 0H8.63313V5.66667H14.2998V4.53333L9.76647 0ZM4.32647 14.0533C4.10255 14.0621 3.88377 13.9848 3.71512 13.8373C3.54648 13.6897 3.44079 13.4831 3.4198 13.26C3.4198 12.4667 4.32647 11.9 5.4598 11.4467C5.4598 11.4166 5.47174 11.3878 5.49299 11.3665C5.51425 11.3453 5.54308 11.3333 5.57313 11.3333C5.98984 10.5357 6.33132 9.70099 6.59313 8.84C6.38215 8.29732 6.2671 7.72209 6.25313 7.14C6.22639 6.87029 6.26527 6.5981 6.36647 6.34667C6.45348 6.21599 6.57143 6.10883 6.70984 6.03472C6.84824 5.9606 7.0028 5.92182 7.1598 5.92182C7.3168 5.92182 7.47136 5.9606 7.60976 6.03472C7.74817 6.10883 7.86612 6.21599 7.95313 6.34667C8.09516 6.58743 8.17319 6.86054 8.1798 7.14C8.14753 7.75687 8.03319 8.36668 7.8398 8.95333C7.98263 9.35244 8.17288 9.73294 8.40647 10.0867C8.63313 10.3133 8.74647 10.54 8.97313 10.6533C9.61642 10.5607 10.2718 10.5993 10.8998 10.7667C11.1068 10.8226 11.2926 10.9385 11.4338 11.0999C11.5749 11.2612 11.6652 11.4608 11.6931 11.6733C11.6696 11.9141 11.5921 12.1466 11.4665 12.3533C11.22 12.5803 10.8948 12.7023 10.5598 12.6933C9.82307 12.6573 9.13048 12.3314 8.63313 11.7867C7.90496 11.8833 7.18513 12.0348 6.4798 12.24C5.68647 13.3733 5.00647 14.0533 4.32647 14.0533ZM7.27313 10.3133C7.1598 10.54 7.1598 10.7667 7.04647 10.9933C7.27313 10.9933 7.4998 10.88 7.72647 10.88C7.5419 10.7205 7.38824 10.5284 7.27313 10.3133Z",
    fill: "#C74343"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPdf);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/pdf.2b761903e704f61ce8b58bbf1989a4b1.svg";